import type { ModePreset } from '@/common/store/pinia/appMode';
import type AcronisHttpAdapter from '@/common/utils/acronisHttpAdapter';

export const buildAcronisWebsocketSettings = (
  api: AcronisHttpAdapter
): Pick<ModePreset, 'websocket'> => {
  const baseURL = api.getInstance().defaults?.baseURL ?? '';
  const headers = api.getHeaders();
  const gateway = {
    'x-oagw-route': headers['x-oagw-route'] as string,
    'x-oagw-tenant': headers['x-oagw-tenant'] as string,
  };

  return {
    websocket: {
      wsUrl: `${baseURL}/ws`,
      vncWebSocketUrl: `${baseURL}/websockify`,
      queryParams: {
        ...gateway,
        'x-project-id': headers['X-Auth-Token'] as string,
      },
      headers: { ...gateway },
    },
  };
};
